import { defaultDataIdFromObject } from 'apollo-cache-inmemory';

export default (object) => {
  switch (object.__typename) {
    case 'StudentManualGradeReport': return `${object.__typename}:${object.attemptId}:${object.componentId}`;
    default: return defaultDataIdFromObject(object);
  }
};
